//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('stockGet', {
//        templateUrl: 'views/components/views/stockGet/stockGet.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'utilityService', 'stateService', 'stockGetService', function ($stateParams, utilityService, stateService, stockGetService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let stockKeyno = $stateParams.stock_keyno;
            
//            vm.model = {
//                productButtons: [
//                    { id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('product', { prod_id: vm.model.edit.prod_keyno  }) }
//                ],
//                stockStockValueButtons: [
//                    { id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('stockbatchlist', { stock_keyno: vm.model.edit.stock_keyno }) }
//                ],
//                stockBatchQtyButtons: [
//                    { id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('stockstockbatchassigned', { stock_keyno: vm.model.edit.stock_keyno }) }
//                ],
//                numberOfLocationsButtons: [
//                    { id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('stockonlocation', { stock_keyno: vm.model.edit.stock_keyno, functionname: 'stock' }) }
//                ],
//                stockStockValueOtherButtons: [
//                    { id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('stockall', { stock_keyno: vm.model.edit.stock_keyno }) }
//                ],
//                stockIncomingButtons: [
//                    { id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('stockincoming', { stock_keyno: vm.model.edit.stock_keyno }) }
//                ],
//                stockOutgoingButtons: [
//                    { id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('stockoutgoing', { stock_keyno: vm.model.edit.stock_keyno }) }
//                ],
//                stockLocationNameButtons: [
//                    { id: 'goto', icon: 'fas fa-search', color: 'primary', type: 'primary', onClick: () => stateService.go('selectstocklocation', { stockplace_id: vm.model.edit.stockplace_id }) }
//                ],
//                edit: {},
//                selectListProdBeoMethods: [],
//                itemsListOwnKpis: [],
//                lockedSave: false
//            };
            
//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE CALL

//            async function loadEdit() {
//                vm.model.edit = (await stockGetService.getStock({ stock_keyno: stockKeyno }))[0];
//            }

//            async function loadProdBeoMethods() {
//                vm.model.selectListProdBeoMethods = await stockGetService.listProdBeoMethods();
//            }

//            async function loadOwnKpis() {
//                if (utilityService.validateParmsValue(vm.model.edit.stock_keyno) !== true) return;

//                return vm.model.itemsListOwnKpis = await stockGetService.listOwnKpis({ stock_keyno: vm.model.edit.stock_keyno });
//            }

//            // #endregion LOAD PROCEDURE CALL
            
//            // #region SAVE BUTTON FUNCTION
            
//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                stockGetService.saveObj(vm.model.edit).then(() => {
//                    vm.model.lockedSave = false;
//                    stateService.back();
//                }, () => vm.model.lockedSave = false);
//            }
            
//            // #endregion SAVE BUTTON FUNCTION

//            // #region MULTI DIRECTION BUTTON FUNCTIONS

//            vm.goToFunc = function (state, e) {
//                function go(parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                }

//                switch (state) {
//                    case 'selectreport':
//                        go({
//                            webpage_name: 'stockget',
//                            argtype: 'stock_keyno',
//                            argvalue: vm.model.edit.stock_keyno
//                        });
//                        break;
//                    default:
//                        break;
//                }
//            };

//		    // #endregion MULTI DIRECTION BUTTON FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                await loadEdit();
//                loadProdBeoMethods();
//                loadOwnKpis();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
